let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6gOq1")).then(() => parcelRequire('jXADX'));